export default __webpack_public_path__ + "_/images/knowledge-center/category-casino-01bf84a4235c75d8dee6c7a6e9732dbd6773271e7b705352ca3e57f0a94c70e6.png";